import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from '../testiGo/components/Header';

import AOS from 'aos';
import '../../node_modules/aos/dist/aos.css';
import Footer from '../testiGo/components/Footer';


const WebRoutes = () => {
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);

  const navigate = useNavigate();
  useEffect(() => {
    if (window.location.pathname === '/testigo') {
      navigate("home");
    }
  }, []);

/// AOS Animation 
  useEffect(() => {
    AOS.init({
      duration: 2500,
    });
    const onScroll = e => {
      setScrollTop(e.target.documentElement.scrollTop);
      setScrolling(e.target.documentElement.scrollTop > scrollTop);
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  )
}
export default WebRoutes;